import { TRAINING_PROGRESS_COPY, DEFAULT_SCHEDULE_COPY, SCHEDULE_TRAINING_COPY } from './training';
import { DOCUMENTS_COPY, STUDENT_DOCUMENTS_COPY } from './documents';
import { STUDY_MATERIALS_COPY, STUDENT_STUDY_MATERIALS_COPY } from './materials';
import { STUDENT_PAYMENTS_COPY } from './payments';

export const T = {
    en: {
        nav: { home: "Home", about: "About", contact: "Contact:", message: "Message", enroll: "New student", login: "Login", logout: "Logout", dashboard: "Dashboard", examPractice: "PERMIT" },
        dashboard: {
            title: "Student Dashboard",
            permit: "PERMIT Practice",
            schedule: "Schedule Training",
            progress: "Training Progress",
            documents: "Documents",
            studyMaterials: "Study Materials",
            payments: "Payments & Discounts"
        },
        dashboardDescriptions: {
            permit: "Practice for your CDL permit exam with interactive questions",
            schedule: "Book your hands-on training sessions with instructors",
            progress: "Track your training progress and completion status",
            documents: "Access your training certificates and important documents",
            studyMaterials: "Access training materials, guides, and resources",
            payments: "View your tuition balance, generate discounts, and submit payments for approval"
        },
        admin: {
            header: {
                default: "Admin Dashboard",
                withName: "{name}'s Admin Dashboard",
                subtitle: "Manage your CDL training platform"
            },
            stats: {
                totalUsers: "Total Users",
                completedStudents: "CDL Course Completed",
                activeSessions: "Active Sessions"
            },
            messages: {
                contentManagementComingSoon: "Content Management - Coming Soon"
            },
            sections: {
                userManagement: {
                    title: "User Management",
                    description: "View, edit, and manage student accounts and instructor profiles"
                },
                questionBank: {
                    title: "Question Bank",
                    description: "Add, edit, and manage CDL practice questions across all categories"
                },
                trainingProgress: {
                    title: "Training Progress",
                    description: "View and manage student training progress across all sections"
                },
                systemSettings: {
                    title: "System Settings",
                    description: "Configure platform settings, categories, and system preferences"
                },
                payments: {
                    title: "Payments & Discounts",
                    description: "Review student balances, approve payments, and manage discounts"
                },
                studyMaterials: {
                    title: "Study Materials",
                    description: "Upload, manage, and organize training documents and resources"
                },
                studentDocuments: {
                    title: "Student Documents",
                    description: "View and manage documents uploaded by students"
                },
                enrollmentMessages: {
                    title: "Enrollment Messages",
                    description: "View and manage student enrollment requests"
                },
                contentManagement: {
                    title: "Content Management",
                    description: "Manage website content and announcements"
                },
                trainingCalendar: {
                    title: "Training Calendar",
                    description: "View weekly calendar organized by trucks with student names and manage appointments"
                }
            },
            modals: {
                documents: {
                    copy: DOCUMENTS_COPY.default,
                },
                studyMaterials: {
                    copy: STUDY_MATERIALS_COPY.default,
                },
                studentDocuments: {
                    copy: STUDENT_DOCUMENTS_COPY.default,
                },
            }
        },
        hero: {
            titleTop: "CDL TRAINING",
            titleBottom: "SCHOOL",
            subtitle: "",
            cta: "New student",
        },
        features: {
            a: { title: "Professional Instructors", desc: "Experienced mentors focused on safety, skill, and confidence." },
            b: { title: "Hands-on Training", desc: "Real equipment, real yards, real driving scenarios." },
            c: { title: "Job Placement Assistance", desc: "Resume help, interview prep, and hiring partners." },
        },
        about: {
            heading: "About Go2 CDL",
            body:
                "At Go2 CDL, we're committed to helping you earn your CDL and launch your driving career with confidence. Our safety-first training program is led by former fleet managers and seasoned over-the-road (OTR) professionals who know exactly what it takes to succeed in today's trucking industry. From day one, you'll practice the skills carriers value most — detailed pre-trip inspections, safe and efficient driving techniques, road test preparation, and real-world trip planning. We go beyond helping you pass the test — we prepare you for the road ahead. We also provide interview coaching, industry insights, and connections with reputable carriers to give you the best start possible.",
        },
        contact: {
            title: "Ready to enroll?",
            subtitle: "Tell us a bit about you and we'll get in touch within one business day.",
            bullets: [
                "FMCSA-compliant training",
                "Financing options",
                "Job placement assistance",
            ],
            form: {
                first: "First name",
                last: "Last name",
                phone: "Phone",
                email: "Email",
                program: "Program",
                programOptions: ["CDL Class A", "Refresher Course", "ELDT Theory"],
                message: "Message",
                messagePH:
                    "Tell us your goals, preferred start date, or questions...",
                submit: "Submit",
            },
        },
    },
    uk: {
        nav: { home: "Головна", about: "Про нас", contact: "Контакти", enroll: "Записатися", login: "Увійти", logout: "Вийти", dashboard: "Кабінет", examPractice: "ПЕРМІТ" },
        dashboard: {
            title: "Студентський кабінет",
            permit: "Практика ПЕРМІТ",
            schedule: "Запланувати тренування",
            progress: "Прогрес тренування",
            documents: "Документи",
            studyMaterials: "Навчальні матеріали",
            payments: "Платежі та знижки"
        },
        dashboardDescriptions: {
            permit: "Практика до екзамену CDL із інтерактивними запитаннями",
            schedule: "Записуйтесь на практичні заняття з інструкторами",
            progress: "Відстежуйте свій прогрес та статус виконання",
            documents: "Отримуйте сертифікати навчання й важливі документи",
            studyMaterials: "Доступ до навчальних матеріалів, посібників і ресурсів",
            payments: "Переглядайте баланс, створюйте знижки та надсилайте платежі на затвердження"
        },
        admin: {
            header: {
                default: "Адмін-панель",
                withName: "Адмін-панель {name}",
                subtitle: "Керуйте платформою підготовки CDL"
            },
            stats: {
                totalUsers: "Усього користувачів",
                completedStudents: "Завершили курс CDL",
                activeSessions: "Активні сесії"
            },
            messages: {
                contentManagementComingSoon: "Керування контентом — невдовзі"
            },
            sections: {
                userManagement: {
                    title: "Керування користувачами",
                    description: "Перегляд, редагування та керування акаунтами студентів і профілями інструкторів"
                },
                questionBank: {
                    title: "Банк запитань",
                    description: "Додавання, редагування та керування практичними CDL-питаннями для всіх категорій"
                },
                trainingProgress: {
                    title: "Прогрес навчання",
                    description: "Перегляд і керування прогресом студентів у всіх розділах"
                },
                systemSettings: {
                    title: "Системні налаштування",
                    description: "Налаштування параметрів платформи, категорій та системних уподобань"
                },
                payments: {
                    title: "Платежі та знижки",
                    description: "Перевірка балансів студентів, затвердження платежів і керування знижками"
                },
                studyMaterials: {
                    title: "Навчальні матеріали",
                    description: "Завантаження, керування та організація навчальних документів і ресурсів"
                },
                studentDocuments: {
                    title: "Документи студентів",
                    description: "Перегляд і керування файлами, які завантажили студенти"
                },
                enrollmentMessages: {
                    title: "Звернення на вступ",
                    description: "Перегляд і обробка заявок на вступ від студентів"
                },
                contentManagement: {
                    title: "Керування контентом",
                    description: "Керування контентом сайту та оголошеннями"
                },
                trainingCalendar: {
                    title: "Календар тренувань",
                    description: "Перегляд тижневого календаря за вантажівками з іменами студентів та керування записами"
                }
            },
            modals: {
                documents: {
                    copy: DOCUMENTS_COPY.uk,
                },
                studyMaterials: {
                    copy: STUDY_MATERIALS_COPY.uk,
                },
                studentDocuments: {
                    copy: STUDENT_DOCUMENTS_COPY.uk,
                },
                trainingProgress: {
                    copy: TRAINING_PROGRESS_COPY.uk.admin,
                    training: TRAINING_PROGRESS_COPY.uk.training,
                },
                payments: {
                    title: "Платежі та знижки (адмін)",
                    subtitle: "Переглядайте баланси студентів, підтверджуйте платежі та керуйте знижками.",
                    loading: "Завантаження менеджера платежів…",
                    buttons: {
                        close: "Закрити",
                        saveDefaults: "Зберегти типові значення",
                        deleteStudent: "Видалити запис платежів",
                        updateAmount: "Оновити суму",
                        revokeDiscount: "Скасувати знижку",
                        invalidateReferral: "Анулювати реферальний код",
                        approve: "Підтвердити",
                        reject: "Відхилити",
                        deletePayment: "Видалити",
                        previewReceipt: "Переглянути",
                        downloadReceipt: "Завантажити квитанцію"
                    },
                    sections: {
                        defaultSettings: {
                            heading: "Типові налаштування платежів",
                            fields: {
                                defaultAmount: "Типова вартість навчання",
                                currency: "Валюта",
                                discountAmount: "Розмір реферальної знижки",
                                referralLevel2Amount: "Сума реферальної винагороди №2",
                                referralLevel3Amount: "Сума реферальної винагороди №3"
                            }
                        },
                        overview: {
                            heading: "Огляд платежів студентів",
                            empty: "Дані про платежі ще відсутні. Студенти з’являться тут після відкриття розділу Платежі та знижки."
                        }
                    },
                    summary: {
                        outstanding: "Залишок до сплати",
                        approved: "Підтверджені платежі",
                        totalTuition: "Загальна вартість",
                        outstandingPill: "Залишок"
                    },
                    studentCard: {
                        defaultName: "Студент",
                        accountCreated: "Акаунт створено: {date}",
                        setTotalTuition: "Встановити загальну вартість",
                        referralHeading: "Реферальні знижки",
                        appliedHeading: "Застосовано до цього студента",
                        appliedEmpty: "Реферальну знижку не застосовано.",
                        appliedCode: "Код:",
                        appliedValue: "Сума:",
                        appliedDate: "Застосовано:",
                        appliedProvider: "Хто надав:",
                        referralGeneratedHeading: "Згенерований реферальний код",
                        referralGeneratedEmpty: "Реферальний код ще не згенеровано.",
                        referralCode: "Код:",
                        referralValue: "Сума:",
                        referralGenerated: "Згенеровано:",
                        referralStatus: "Статус:",
                        referralStatusAssigned: "Призначено {name}",
                        referralStatusAssignedFallback: "іншому студенту",
                        referralStatusInvalidated: "Недійсний",
                        referralStatusAvailable: "Доступний для поширення",
                        paymentsHeading: "Платежі",
                        paymentsEmpty: "Платежів ще немає.",
                        columns: {
                            date: "Дата",
                            amount: "Сума",
                            method: "Метод",
                            status: "Статус",
                            notes: "Примітки",
                            receipt: "Квитанція",
                            actions: "Дії"
                        }
                    },
                    preview: {
                        title: "Перегляд квитанції",
                        close: "Закрити перегляд",
                        unsupported: "Перегляд недоступний. Завантажте файл, щоб переглянути його.",
                        loading: "Завантаження квитанції…",
                        error: "Не вдалося завантажити попередній перегляд квитанції."
                    },
                    messages: {
                        settingsUpdated: "Типові налаштування платежів оновлено. Нові студенти використовуватимуть ці значення.",
                        studentAmountUpdated: "Суму для студента оновлено.",
                        paymentApproved: "Платіж підтверджено.",
                        paymentRejected: "Платіж відхилено.",
                        paymentUpdated: "Статус платежу оновлено.",
                        paymentRemoved: "Платіж видалено.",
                        discountRevoked: "Знижку скасовано.",
                        referralInvalidated: "Реферальний код анульовано.",
                        studentRecordDeleted: "Запис платежів студента видалено.",
                        referralApplied: "Реферальний код {code} успішно застосовано.",
                        referralGenerated: "Реферальний код {code} згенеровано! Поділіться ним із новим студентом, щоб він отримав знижку {amount} на навчання.",
                        referralGeneratedNoAmount: "Реферальний код {code} згенеровано! Поділіться ним із новим студентом.",
                        paymentSubmitted: "Платіж надіслано на підтвердження."
                    },
                    errors: {
                        loadOverview: "Не вдалося завантажити огляд платежів.",
                        defaultAmountInvalid: "Введіть коректну типову суму.",
                        discountAmountInvalid: "Введіть коректний розмір знижки.",
                        referralLevel2AmountInvalid: "Введіть коректну суму для Рефералу №2.",
                        referralLevel3AmountInvalid: "Введіть коректну суму для Рефералу №3.",
                        studentAmountInvalid: "Введіть коректну суму для студента.",
                        enterReferralCode: "Введіть реферальний код.",
                        paymentAmountInvalid: "Введіть коректну суму платежу.",
                        amountExceeds: "Сума перевищує залишок до сплати.",
                        requestFailed: "Запит не виконано.",
                        referralGenerateFailed: "Не вдалося згенерувати реферальний код.",
                        referralApplyFailed: "Не вдалося застосувати реферальний код.",
                        paymentSubmitFailed: "Не вдалося надіслати платіж."
                    },
                    confirm: {
                        deleteStudent: "Видалити запис платежів студента? Це прибере всі платежі та скине знижки."
                    },
                    statuses: {
                        APPROVED: "Підтверджено",
                        PENDING: "Очікує",
                        REJECTED: "Відхилено"
                    }
                }
            }
        },
        student: {
            modals: {
                payments: {
                    copy: STUDENT_PAYMENTS_COPY.uk,
                },
                schedule: {
                    header: {
                        title: SCHEDULE_TRAINING_COPY.uk.header.title,
                    },
                    schedule: SCHEDULE_TRAINING_COPY.uk,
                },
                trainingProgress: {
                    header: {
                        title: TRAINING_PROGRESS_COPY.uk.studentHeader,
                    },
                    training: TRAINING_PROGRESS_COPY.uk.training,
                },
                documents: {
                    copy: DOCUMENTS_COPY.uk,
                },
                studyMaterials: {
                    student: STUDENT_STUDY_MATERIALS_COPY.uk,
                },
            },
        },
        hero: {
            titleTop: "ШКОЛА CDL",
            subtitle:
                "Навчання з професійними інструкторами, практика на техніці та допомога з працевлаштуванням.",
            cta: "Записатися",
        },
        features: {
            a: { title: "Професійні інструктори", desc: "Досвідчені наставники з фокусом на безпеку та впевненість." },
            b: { title: "Практичне навчання", desc: "Справжня техніка, полігони та реальні ситуації на дорозі." },
            c: { title: "Допомога з працевлаштуванням", desc: "Резюме, підготовка до співбесіди та партнери-роботодавці." },
        },
        about: {
            heading: "Про Go2 CDL",
            body:
                "У Go2 CDL ми допоможемо вам отримати CDL і впевнено стартувати кар'єру водія. Наш курс безпеки ведуть колишні менеджери автопарків та досвідчені OTR-фахівці. З першого дня ви відпрацьовуєте навички, які цінують перевізники: передрейсовий огляд, безпечні прийоми водіння, підготовка до іспиту та реальне планування рейсів. Ми не лише готуємо до іспиту — ми готуємо до дороги попереду. Також надаємо підготовку до співбесід, інсайти індустрії та контакти з надійними компаніями.",
        },
        contact: {
            title: "Готові записатися?",
            subtitle:
                "Розкажіть трохи про себе — ми зв'яжемося з вами протягом одного робочого дня.",
            bullets: [
                "Навчання згідно з вимогами FMCSA",
                "Фінансові програми",
                "Допомога з працевлаштуванням",
            ],
            form: {
                first: "Ім'я",
                last: "Прізвище",
                phone: "Телефон",
                email: "Ел. пошта",
                program: "Програма",
                programOptions: ["CDL Class A", "Курс-поновлення", "ELDT Теорія"],
                message: "Повідомлення",
                messagePH: "Ваші цілі, бажана дата старту чи запитання...",
                submit: "Надіслати",
            },
        },
    },
    ru: {
        nav: { home: "Главная", about: "О нас", contact: "Контакты", enroll: "Записатися", login: "Войти", logout: "Выйти", dashboard: "Кабинет", examPractice: "ПЕРМИТ" },
        dashboard: {
            title: "Студенческий кабинет",
            permit: "Практика ПЕРМИТ",
            schedule: "Запланировать тренировку",
            progress: "Прогресс тренировки",
            documents: "Документы",
            studyMaterials: "Учебные материалы",
            payments: "Платежи и скидки"
        },
        dashboardDescriptions: {
            permit: "Подготовка к экзамену CDL с интерактивными вопросами",
            schedule: "Записывайтесь на практические занятия с инструкторами",
            progress: "Отслеживайте прогресс обучения и статус выполнения",
            documents: "Получайте доступ к сертификатам обучения и важным документам",
            studyMaterials: "Доступ к учебным материалам, пособиям и ресурсам",
            payments: "Просматривайте баланс, оформляйте скидки и отправляйте платежи на утверждение"
        },
        admin: {
            header: {
                default: "Админ-панель",
                withName: "Админ-панель {name}",
                subtitle: "Управляйте платформой подготовки CDL"
            },
            stats: {
                totalUsers: "Всего пользователей",
                completedStudents: "Прошли курс CDL",
                activeSessions: "Активные сессии"
            },
            messages: {
                contentManagementComingSoon: "Управление контентом — скоро"
            },
            sections: {
                userManagement: {
                    title: "Управление пользователями",
                    description: "Просмотр, редактирование и управление учетными записями студентов и профилями инструкторов"
                },
                questionBank: {
                    title: "Банк вопросов",
                    description: "Добавляйте, редактируйте и управляйте практическими вопросами CDL для всех категорий"
                },
                trainingProgress: {
                    title: "Прогресс обучения",
                    description: "Просматривайте и управляйте прогрессом студентов во всех разделах"
                },
                systemSettings: {
                    title: "Настройки системы",
                    description: "Настраивайте параметры платформы, категории и системные предпочтения"
                },
                payments: {
                    title: "Платежи и скидки",
                    description: "Просматривайте балансы студентов, утверждайте платежи и управляйте скидками"
                },
                studyMaterials: {
                    title: "Учебные материалы",
                    description: "Загружайте, организуйте и управляйте учебными документами и ресурсами"
                },
                studentDocuments: {
                    title: "Документы студентов",
                    description: "Просматривайте и управляйте файлами, загруженными студентами"
                },
                enrollmentMessages: {
                    title: "Заявки на поступление",
                    description: "Просматривайте и обрабатывайте заявки на обучение от студентов"
                },
                contentManagement: {
                    title: "Управление контентом",
                    description: "Управляйте контентом сайта и объявлениями"
                },
                trainingCalendar: {
                    title: "Календарь тренировок",
                    description: "Просматривайте недельный календарь по грузовикам со студентами и управляйте записями"
                }
            },
            modals: {
                documents: {
                    copy: DOCUMENTS_COPY.ru,
                },
                studyMaterials: {
                    copy: STUDY_MATERIALS_COPY.ru,
                },
                studentDocuments: {
                    copy: STUDENT_DOCUMENTS_COPY.ru,
                },
                trainingProgress: {
                    copy: TRAINING_PROGRESS_COPY.ru.admin,
                    training: TRAINING_PROGRESS_COPY.ru.training,
                },
                payments: {
                    title: "Платежи и скидки (админ)",
                    subtitle: "Просматривайте балансы студентов, утверждайте платежи и управляйте скидками.",
                    loading: "Загрузка менеджера платежей…",
                    buttons: {
                        close: "Закрыть",
                        saveDefaults: "Сохранить по умолчанию",
                        deleteStudent: "Удалить запись платежей",
                        updateAmount: "Обновить сумму",
                        revokeDiscount: "Отменить скидку",
                        invalidateReferral: "Аннулировать реферальный код",
                        approve: "Одобрить",
                        reject: "Отклонить",
                        deletePayment: "Удалить",
                        previewReceipt: "Просмотр",
                        downloadReceipt: "Скачать квитанцию"
                    },
                    sections: {
                        defaultSettings: {
                            heading: "Настройки платежей по умолчанию",
                            fields: {
                                defaultAmount: "Стандартная стоимость обучения",
                                currency: "Валюта",
                                discountAmount: "Размер реферальной скидки",
                                referralLevel2Amount: "Сумма реферальной выплаты №2",
                                referralLevel3Amount: "Сумма реферальной выплаты №3"
                            }
                        },
                        overview: {
                            heading: "Обзор платежей студентов",
                            empty: "Данные о платежах пока отсутствуют. Студенты появятся здесь после открытия раздела Платежи и скидки."
                        }
                    },
                    summary: {
                        outstanding: "Остаток к оплате",
                        approved: "Одобренные платежи",
                        totalTuition: "Общая стоимость",
                        outstandingPill: "Остаток"
                    },
                    studentCard: {
                        defaultName: "Студент",
                        accountCreated: "Учетная запись создана: {date}",
                        setTotalTuition: "Установить общую стоимость",
                        referralHeading: "Реферальные скидки",
                        appliedHeading: "Применено к этому студенту",
                        appliedEmpty: "Реферальная скидка не применена.",
                        appliedCode: "Код:",
                        appliedValue: "Сумма:",
                        appliedDate: "Применено:",
                        appliedProvider: "Кем предоставлено:",
                        referralGeneratedHeading: "Сгенерированный реферальный код",
                        referralGeneratedEmpty: "Реферальный код еще не сгенерирован.",
                        referralCode: "Код:",
                        referralValue: "Сумма:",
                        referralGenerated: "Создан:",
                        referralStatus: "Статус:",
                        referralStatusAssigned: "Назначено {name}",
                        referralStatusAssignedFallback: "другому студенту",
                        referralStatusInvalidated: "Аннулирован",
                        referralStatusAvailable: "Доступен для передачи",
                        paymentsHeading: "Платежи",
                        paymentsEmpty: "Платежи еще не отправлены.",
                        columns: {
                            date: "Дата",
                            amount: "Сумма",
                            method: "Метод",
                            status: "Статус",
                            notes: "Примечания",
                            receipt: "Квитанция",
                            actions: "Действия"
                        }
                    },
                    preview: {
                        title: "Просмотр квитанции",
                        close: "Закрыть просмотр",
                        unsupported: "Предпросмотр недоступен. Скачайте файл, чтобы просмотреть его.",
                        loading: "Загрузка квитанции…",
                        error: "Не удалось загрузить предпросмотр квитанции."
                    },
                    messages: {
                        settingsUpdated: "Настройки платежей по умолчанию обновлены. Новые студенты будут использовать эти значения.",
                        studentAmountUpdated: "Сумма для студента обновлена.",
                        paymentApproved: "Платеж одобрен.",
                        paymentRejected: "Платеж отклонен.",
                        paymentUpdated: "Статус платежа обновлен.",
                        paymentRemoved: "Платеж удален.",
                        discountRevoked: "Скидка отменена.",
                        referralInvalidated: "Реферальный код аннулирован.",
                        studentRecordDeleted: "Запись платежей студента удалена.",
                        referralApplied: "Реферальный код {code} успешно применен.",
                        referralGenerated: "Реферальный код {code} создан! Поделитесь им с новым студентом, чтобы он получил скидку {amount} на обучение.",
                        referralGeneratedNoAmount: "Реферальный код {code} создан! Поделитесь им с новым студентом.",
                        paymentSubmitted: "Платеж отправлен на утверждение."
                    },
                    errors: {
                        loadOverview: "Не удалось загрузить обзор платежей.",
                        defaultAmountInvalid: "Введите корректную стандартную сумму.",
                        discountAmountInvalid: "Введите корректный размер скидки.",
                        referralLevel2AmountInvalid: "Введите корректную сумму для Реферала №2.",
                        referralLevel3AmountInvalid: "Введите корректную сумму для Реферала №3.",
                        studentAmountInvalid: "Введите корректную сумму для студента.",
                        enterReferralCode: "Введите реферальный код.",
                        paymentAmountInvalid: "Введите корректную сумму платежа.",
                        amountExceeds: "Сумма превышает оставшийся баланс.",
                        requestFailed: "Запрос не выполнен.",
                        referralGenerateFailed: "Не удалось сгенерировать реферальный код.",
                        referralApplyFailed: "Не удалось применить реферальный код.",
                        paymentSubmitFailed: "Не удалось отправить платеж."
                    },
                    confirm: {
                        deleteStudent: "Удалить запись платежей студента? Это удалит все платежи и сбросит скидки."
                    },
                    statuses: {
                        APPROVED: "Одобрено",
                        PENDING: "В ожидании",
                        REJECTED: "Отклонено"
                    }
                }
            }
        },
        student: {
            modals: {
                payments: {
                    copy: STUDENT_PAYMENTS_COPY.ru,
                },
                schedule: {
                    header: {
                        title: SCHEDULE_TRAINING_COPY.ru.header.title,
                    },
                    schedule: SCHEDULE_TRAINING_COPY.ru,
                },
                trainingProgress: {
                    header: {
                        title: TRAINING_PROGRESS_COPY.ru.studentHeader,
                    },
                    training: TRAINING_PROGRESS_COPY.ru.training,
                },
                documents: {
                    copy: DOCUMENTS_COPY.ru,
                },
                studyMaterials: {
                    student: STUDENT_STUDY_MATERIALS_COPY.ru,
                },
            },
        },
        hero: {
            titleTop: "ШКОЛА CDL",
            subtitle:
                "Учитесь у профессиональных инструкторов, тренируйтесь на технике и получайте помощь с трудоустройством.",
            cta: "Записаться",
        },
        features: {
            a: { title: "Профессиональные инструкторы", desc: "Опытные наставники с акцентом на безопасность и уверенность." },
            b: { title: "Практические занятия", desc: "Реальная техника, полигоны и жизненные сценарии на дороге." },
            c: { title: "Помощь с трудоустройством", desc: "Резюме, подготовка к интервью и партнеры-работодатели." },
        },
        about: {
            heading: "О Go2 CDL",
            body:
                "В Go2 CDL мы помогаем получить CDL и уверенно начать карьеру водителя. Нашу программу безопасности ведут бывшие менеджеры автопарков и опытные OTR-профессионалы. С первого дня вы осваиваете навыки, которые ценят перевозчики: детальный предрейсовый осмотр, безопасные приемы вождения, подготовка к экзамену и планирование рейсов. Мы не просто готовим к экзамену — мы готовим к дороге впереди. Также помогаем с подготовкой к собеседованию, делимся знаниями отрасли и контактами надежных компаний.",
        },
        contact: {
            title: "Готовы записаться?",
            subtitle:
                "Расскажите немного о себе — мы свяжемся с вами в течение одного рабочего дня.",
            bullets: [
                "Обучение в соответствии с требованиями FMCSA",
                "Варианты финансирования",
                "Помощь с трудоустройством",
            ],
            form: {
                first: "Имя",
                last: "Фамилия",
                phone: "Телефон",
                email: "Email",
                program: "Программа",
                programOptions: ["CDL Class A", "Курс-рефреш", "ELDT Теория"],
                message: "Сообщение",
                messagePH: "Ваши цели, желаемая дата начала или вопросы...",
                submit: "Отправить",
            },
        },
    },
    es: {
        nav: { home: "Inicio", about: "Acerca de", contact: "Contacto", enroll: "Inscríbete", login: "Entrar", logout: "Salir", dashboard: "Panel", examPractice: "PERMISO" },
        dashboard: {
            title: "Panel del Estudiante",
            permit: "Práctica de PERMISO",
            schedule: "Programar Entrenamiento",
            progress: "Progreso del Entrenamiento",
            documents: "Documentos",
            studyMaterials: "Materiales de Estudio",
            payments: "Pagos y Descuentos"
        },
        dashboardDescriptions: {
            permit: "Practica para tu examen de permiso CDL con preguntas interactivas",
            schedule: "Agenda tus sesiones prácticas con instructores",
            progress: "Sigue tu progreso de entrenamiento y estado de finalización",
            documents: "Accede a tus certificados de entrenamiento e importantes documentos",
            studyMaterials: "Accede a materiales de estudio, guías y recursos",
            payments: "Consulta tu saldo, genera descuentos y envía pagos para aprobación"
        },
        admin: {
            header: {
                default: "Panel de Administración",
                withName: "Panel de Administración de {name}",
                subtitle: "Administra tu plataforma de entrenamiento CDL"
            },
            stats: {
                totalUsers: "Usuarios totales",
                completedStudents: "Curso CDL completado",
                activeSessions: "Sesiones activas"
            },
            messages: {
                contentManagementComingSoon: "Gestión de contenido — muy pronto"
            },
            sections: {
                userManagement: {
                    title: "Gestión de Usuarios",
                    description: "Visualiza, edita y administra cuentas de estudiantes y perfiles de instructores"
                },
                questionBank: {
                    title: "Banco de Preguntas",
                    description: "Agrega, edita y administra preguntas de práctica CDL en todas las categorías"
                },
                trainingProgress: {
                    title: "Progreso de Entrenamiento",
                    description: "Revisa y gestiona el progreso de los estudiantes en cada sección"
                },
                systemSettings: {
                    title: "Configuración del Sistema",
                    description: "Configura ajustes de la plataforma, categorías y preferencias generales"
                },
                payments: {
                    title: "Pagos y Descuentos",
                    description: "Revisa saldos de estudiantes, aprueba pagos y gestiona descuentos"
                },
                studyMaterials: {
                    title: "Materiales de Estudio",
                    description: "Sube, organiza y administra documentos y recursos de entrenamiento"
                },
                studentDocuments: {
                    title: "Documentos de Estudiantes",
                    description: "Revisa y gestiona los archivos cargados por los estudiantes"
                },
                enrollmentMessages: {
                    title: "Solicitudes de Inscripción",
                    description: "Revisa y gestiona las solicitudes de inscripción de los estudiantes"
                },
                contentManagement: {
                    title: "Gestión de Contenido",
                    description: "Administra el contenido del sitio web y los avisos"
                },
                trainingCalendar: {
                    title: "Calendario de Entrenamientos",
                    description: "Consulta el calendario semanal por camión con los estudiantes y gestiona citas"
                }
            },
            modals: {
                documents: {
                    copy: DOCUMENTS_COPY.es,
                },
                studyMaterials: {
                    copy: STUDY_MATERIALS_COPY.es,
                },
                studentDocuments: {
                    copy: STUDENT_DOCUMENTS_COPY.es,
                },
                trainingProgress: {
                    copy: TRAINING_PROGRESS_COPY.es.admin,
                    training: TRAINING_PROGRESS_COPY.es.training,
                },
                payments: {
                    title: "Pagos y descuentos (admin)",
                    subtitle: "Revisa los saldos de los estudiantes, aprueba pagos y administra descuentos.",
                    loading: "Cargando administrador de pagos…",
                    buttons: {
                        close: "Cerrar",
                        saveDefaults: "Guardar valores predeterminados",
                        deleteStudent: "Eliminar registro de pagos",
                        updateAmount: "Actualizar monto",
                        revokeDiscount: "Cancelar descuento",
                        invalidateReferral: "Anular código de referido",
                        approve: "Aprobar",
                        reject: "Rechazar",
                        deletePayment: "Eliminar",
                        previewReceipt: "Vista previa",
                        downloadReceipt: "Descargar comprobante"
                    },
                    sections: {
                        defaultSettings: {
                            heading: "Configuración de pagos predeterminada",
                            fields: {
                                defaultAmount: "Costo de matrícula predeterminado",
                                currency: "Moneda",
                                discountAmount: "Monto de descuento por referido",
                                referralLevel2Amount: "Monto de Referido n.º 2",
                                referralLevel3Amount: "Monto de Referido n.º 3"
                            }
                        },
                        overview: {
                            heading: "Resumen de pagos de estudiantes",
                            empty: "Aún no hay datos de pagos. Los estudiantes aparecerán aquí cuando abran la herramienta Pagos y descuentos."
                        }
                    },
                    summary: {
                        outstanding: "Saldo pendiente",
                        approved: "Pagos aprobados",
                        totalTuition: "Costo total",
                        outstandingPill: "Pendiente"
                    },
                    studentCard: {
                        defaultName: "Estudiante",
                        accountCreated: "Cuenta creada: {date}",
                        setTotalTuition: "Definir costo total",
                        referralHeading: "Descuentos por referido",
                        appliedHeading: "Aplicado a este estudiante",
                        appliedEmpty: "No se aplicó descuento por referido.",
                        appliedCode: "Código:",
                        appliedValue: "Monto:",
                        appliedDate: "Aplicado:",
                        appliedProvider: "Otorgado por:",
                        referralGeneratedHeading: "Código de referido generado",
                        referralGeneratedEmpty: "Aún no se generó un código de referido.",
                        referralCode: "Código:",
                        referralValue: "Monto:",
                        referralGenerated: "Generado:",
                        referralStatus: "Estado:",
                        referralStatusAssigned: "Asignado a {name}",
                        referralStatusAssignedFallback: "otro estudiante",
                        referralStatusInvalidated: "Anulado",
                        referralStatusAvailable: "Disponible para compartir",
                        paymentsHeading: "Pagos",
                        paymentsEmpty: "No se han enviado pagos.",
                        columns: {
                            date: "Fecha",
                            amount: "Monto",
                            method: "Método",
                            status: "Estado",
                            notes: "Notas",
                            receipt: "Comprobante",
                            actions: "Acciones"
                        }
                    },
                    preview: {
                        title: "Vista previa del comprobante",
                        close: "Cerrar vista previa",
                        unsupported: "Vista previa no disponible. Descarga el archivo para verlo.",
                        loading: "Cargando comprobante…",
                        error: "No se pudo cargar la vista previa del comprobante."
                    },
                    messages: {
                        settingsUpdated: "La configuración predeterminada de pagos se actualizó. Los nuevos estudiantes usarán estos valores.",
                        studentAmountUpdated: "El monto del estudiante se actualizó.",
                        paymentApproved: "Pago aprobado.",
                        paymentRejected: "Pago rechazado.",
                        paymentUpdated: "Estado del pago actualizado.",
                        paymentRemoved: "Pago eliminado.",
                        discountRevoked: "Descuento cancelado.",
                        referralInvalidated: "Código de referido anulado.",
                        studentRecordDeleted: "Registro de pagos del estudiante eliminado.",
                        referralApplied: "Código {code} aplicado correctamente.",
                        referralGenerated: "¡Código {code} generado! Compártelo con un nuevo estudiante para que reciba un descuento de {amount} en su matrícula.",
                        referralGeneratedNoAmount: "¡Código {code} generado! Compártelo con un nuevo estudiante.",
                        paymentSubmitted: "Pago enviado para aprobación."
                    },
                    errors: {
                        loadOverview: "No se pudo cargar el resumen de pagos.",
                        defaultAmountInvalid: "Ingresa un monto predeterminado válido.",
                        discountAmountInvalid: "Ingresa un monto de descuento válido.",
                        referralLevel2AmountInvalid: "Ingresa un monto válido para Referido n.º 2.",
                        referralLevel3AmountInvalid: "Ingresa un monto válido para Referido n.º 3.",
                        studentAmountInvalid: "Ingresa un monto válido para el estudiante.",
                        enterReferralCode: "Ingresa un código de referido.",
                        paymentAmountInvalid: "Ingresa un monto de pago válido.",
                        amountExceeds: "El monto supera el saldo pendiente.",
                        requestFailed: "La solicitud falló.",
                        referralGenerateFailed: "No se pudo generar el código de referido.",
                        referralApplyFailed: "No se pudo aplicar el código de referido.",
                        paymentSubmitFailed: "No se pudo enviar el pago."
                    },
                    confirm: {
                        deleteStudent: "¿Eliminar el registro de pagos del estudiante? Esto eliminará los pagos y reiniciará los descuentos."
                    },
                    statuses: {
                        APPROVED: "Aprobado",
                        PENDING: "Pendiente",
                        REJECTED: "Rechazado"
                    }
                }
            }
        },
        student: {
            modals: {
                payments: {
                    copy: STUDENT_PAYMENTS_COPY.es,
                },
                schedule: {
                    header: {
                        title: SCHEDULE_TRAINING_COPY.es.header.title,
                    },
                    schedule: SCHEDULE_TRAINING_COPY.es,
                },
                trainingProgress: {
                    header: {
                        title: TRAINING_PROGRESS_COPY.es.studentHeader,
                    },
                    training: TRAINING_PROGRESS_COPY.es.training,
                },
                documents: {
                    copy: DOCUMENTS_COPY.es,
                },
                studyMaterials: {
                    student: STUDENT_STUDY_MATERIALS_COPY.es,
                },
            },
        },
        hero: {
            titleTop: "ENTRENAMIENTO CDL",
            titleBottom: "ESCUELA",
            subtitle:
                "Aprende con instructores profesionales, entrena en vehículo real y recibe ayuda para conseguir trabajo.",
            cta: "Inscríbete",
        },
        features: {
            a: { title: "Instructores profesionales", desc: "Mentores con experiencia enfocados en seguridad, habilidad y confianza." },
            b: { title: "Entrenamiento práctico", desc: "Equipo real, patios de práctica y escenarios reales de conducción." },
            c: { title: "Asistencia laboral", desc: "Ayuda con el currículum, entrevistas y empleadores asociados." },
        },
        about: {
            heading: "Acerca de Go2 CDL",
            body:
                "En Go2 CDL te ayudamos a obtener tu CDL y a iniciar tu carrera con confianza. Nuestro programa con enfoque en seguridad es impartido por ex gerentes de flota y profesionales OTR con amplia experiencia. Desde el primer día practicas las habilidades que valoran los empleadores: inspección previa al viaje, técnicas de conducción seguras y eficientes, preparación para el examen y planificación real de rutas. No solo te ayudamos a aprobar: te preparamos para la carretera. También ofrecemos preparación para entrevistas, información del sector y conexiones con transportistas confiables.",
        },
        contact: {
            title: "¿Listo para inscribirte?",
            subtitle:
                "Cuéntanos un poco sobre ti y te contactaremos dentro de un día hábil.",
            bullets: [
                "Entrenamiento conforme a FMCSA",
                "Opciones de financiamiento",
                "Asistencia de colocación laboral",
            ],
            form: {
                first: "Nombre",
                last: "Apellido",
                phone: "Teléfono",
                email: "Correo electrónico",
                program: "Programa",
                programOptions: ["CDL Clase A", "Curso de repaso", "ELDT Teoría"],
                message: "Mensaje",
                messagePH: "Cuéntanos tus metas, fecha de inicio o preguntas...",
                submit: "Enviar",
            },
        },
    },
};
